import React from 'react';
import { Box, Stack, Typography, IconButton } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

const FormHeader = ({ title, fullName, onBack }) => (
  <Box sx={{ 
    position: 'sticky', top: 0, zIndex: 10, 
    bgcolor: 'rgba(255, 255, 255, 0.8)', backdropFilter: 'blur(8px)',
    pb: 2, mb: 4, borderBottom: '1px solid #eaecf0' 
  }}>
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Stack direction="row" spacing={2} alignItems="center">
        <IconButton onClick={onBack} sx={{ border: '1px solid #eaecf0', bgcolor: '#fff', '&:hover': { bgcolor: '#f9fafb' } }}>
          <ArrowBack />
        </IconButton>
        <Box>
          <Typography variant="h4" fontWeight={900} sx={{ letterSpacing: '-0.04em', color: '#101828' }}>
            {title}
          </Typography>
          <Typography variant="body2" fontWeight={500} color="#667085">
            Initial Assessment for {fullName}
          </Typography>
        </Box>
      </Stack>
    </Stack>
  </Box>
);

export default FormHeader;